module.exports = __webpack_public_path__ + "static/contact-c7ddb26214dcc9cac7d31feb10cef8d2.jpg";